import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';

import SearchBar from '../Search';
import Help from '../Help';
import Profile from '../Profile';
import { SettingActionLoader } from '../../Loader';
import { StyledHeaderActionWrapper } from './style';

import { DYNAMIC_REMOTES } from '~/config/app.constants';
import { CompanyInfo, IntlType, UserInfo } from '~/components/GlobalHeader/Shared/type';

type SettingsProps = {
  company: CompanyInfo;
  user: UserInfo;
  logout: Function;
  activeTab: string;
  className?: string;
  search?: boolean;
  intl: IntlType;
};

const Settings = ({ company, user, logout, activeTab, className, search, intl }: SettingsProps) => (
  <StyledHeaderActionWrapper className={className} data-testid={'global-header-actions'}>
    <SearchBar customSearch={search} activeTab={activeTab} />
    <Help user={user} company={company} />
    <LoadRemote lazy={false} loader={<SettingActionLoader />} remote={DYNAMIC_REMOTES.KEA_CORE} />
    <Profile user={user} company={company} logout={logout} intl={intl} />
  </StyledHeaderActionWrapper>
);

export default Settings;
